export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8197.1e1afa32.jpg";